import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type { IApiGenerateArticleShareUrlResponseBody } from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseCreateArticleDraftMutationValues = {
  appId: string;
  articleId: string;
};

export const useGenerateArticleShareUrlMutation = (): UseMutationResult<
  IApiGenerateArticleShareUrlResponseBody,
  unknown,
  IUseCreateArticleDraftMutationValues
> => {
  const api = useApi();

  return useMutation({
    mutationFn: (values: IUseCreateArticleDraftMutationValues) =>
      api.articles.generateShareUrl(values.appId, values.articleId),
  });
};
